var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/dom"] = t() : (e.wp = e.wp || {}, e.wp.dom = t());
}(self, function () {
  return e = {
    424: function _(e) {
      e.exports = function _interopRequireDefault(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
    },
    513: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getFilesFromDataTransfer = function getFilesFromDataTransfer(e) {
        var t = Array.from(e.files);
        return Array.from(e.items).forEach(function (e) {
          var n = e.getAsFile();
          n && !t.find(function (e) {
            var t = e.name,
                r = e.type,
                o = e.size;
            return t === n.name && r === n.type && o === n.size;
          }) && t.push(n);
        }), t;
      };
    },
    734: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function caretRangeFromPoint(e, t, n) {
        if (e.caretRangeFromPoint) return e.caretRangeFromPoint(t, n);
        if (!e.caretPositionFromPoint) return null;
        var r = e.caretPositionFromPoint(t, n);
        if (!r) return null;
        var o = e.createRange();
        return o.setStart(r.offsetNode, r.offset), o.collapse(!0), o;
      };
    },
    646: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function cleanNodeList(e, t, n, r) {
        Array.from(e).forEach(function (e) {
          var c, f;
          var b = e.nodeName.toLowerCase();

          if (n.hasOwnProperty(b) && (!n[b].isMatch || null !== (c = (f = n[b]).isMatch) && void 0 !== c && c.call(f, e))) {
            if ((0, d.default)(e)) {
              var _n$b = n[b],
                  _n$b$attributes = _n$b.attributes,
                  _l = _n$b$attributes === void 0 ? [] : _n$b$attributes,
                  _n$b$classes = _n$b.classes,
                  _d = _n$b$classes === void 0 ? [] : _n$b$classes,
                  _c = _n$b.children,
                  _n$b$require = _n$b.require,
                  _f = _n$b$require === void 0 ? [] : _n$b$require,
                  p = _n$b.allowEmpty;

              if (_c && !p && (0, a.default)(e)) return void (0, i.default)(e);

              if (e.hasAttributes() && (Array.from(e.attributes).forEach(function (t) {
                var n = t.name;
                "class" === n || (0, o.includes)(_l, n) || e.removeAttribute(n);
              }), e.classList && e.classList.length)) {
                var _t = _d.map(function (e) {
                  return "string" == typeof e ? function (t) {
                    return t === e;
                  } : e instanceof RegExp ? function (t) {
                    return e.test(t);
                  } : o.noop;
                });

                Array.from(e.classList).forEach(function (n) {
                  _t.some(function (e) {
                    return e(n);
                  }) || e.classList.remove(n);
                }), e.classList.length || e.removeAttribute("class");
              }

              if (e.hasChildNodes()) {
                if ("*" === _c) return;
                if (_c) _f.length && !e.querySelector(_f.join(",")) ? (cleanNodeList(e.childNodes, t, n, r), (0, u.default)(e)) : e.parentNode && "BODY" === e.parentNode.nodeName && (0, s.isPhrasingContent)(e) ? (cleanNodeList(e.childNodes, t, n, r), Array.from(e.childNodes).some(function (e) {
                  return !(0, s.isPhrasingContent)(e);
                }) && (0, u.default)(e)) : cleanNodeList(e.childNodes, t, _c, r);else for (; e.firstChild;) {
                  (0, i.default)(e.firstChild);
                }
              }
            }
          } else cleanNodeList(e.childNodes, t, n, r), r && !(0, s.isPhrasingContent)(e) && e.nextElementSibling && (0, l.default)(t.createElement("br"), e), (0, u.default)(e);
        });
      };
      var o = n(793),
          a = r(n(953)),
          i = r(n(314)),
          u = r(n(14)),
          s = n(561),
          l = r(n(78)),
          d = r(n(742));
    },
    591: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function computeCaretRect(e) {
        var t = e.getSelection();
        (0, a.assertIsDefined)(t, "selection");
        var n = t.rangeCount ? t.getRangeAt(0) : null;
        return n ? (0, o.default)(n) : null;
      };
      var o = r(n(605)),
          a = n(86);
    },
    946: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function documentHasSelection(e) {
        return !!e.activeElement && ((0, o.default)(e.activeElement) || (0, a.default)(e.activeElement) || (0, i.default)(e));
      };
      var o = r(n(906)),
          a = r(n(721)),
          i = r(n(87));
    },
    87: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function documentHasTextSelection(e) {
        (0, r.assertIsDefined)(e.defaultView, "doc.defaultView");
        var t = e.defaultView.getSelection();
        (0, r.assertIsDefined)(t, "selection");
        var n = t.rangeCount ? t.getRangeAt(0) : null;
        return !!n && !n.collapsed;
      };
      var r = n(86);
    },
    73: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function documentHasUncollapsedSelection(e) {
        return (0, o.default)(e) || !!e.activeElement && (0, a.default)(e.activeElement);
      };
      var o = r(n(87)),
          a = r(n(512));
    },
    896: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function getComputedStyle(e) {
        return (0, r.assertIsDefined)(e.ownerDocument.defaultView, "element.ownerDocument.defaultView"), e.ownerDocument.defaultView.getComputedStyle(e);
      };
      var r = n(86);
    },
    723: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function getOffsetParent(e) {
        var t;

        for (; (t = e.parentNode) && t.nodeType !== t.ELEMENT_NODE;) {
          ;
        }

        return t ? "static" !== (0, o.default)(t).position ? t : t.offsetParent : null;
      };
      var o = r(n(896));
    },
    576: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function getRangeHeight(e) {
        var t = Array.from(e.getClientRects());
        if (!t.length) return;
        var n = Math.min.apply(Math, _toConsumableArray(t.map(function (e) {
          var t = e.top;
          return t;
        })));
        return Math.max.apply(Math, _toConsumableArray(t.map(function (e) {
          var t = e.bottom;
          return t;
        }))) - n;
      };
    },
    605: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function getRectangleFromRange(e) {
        if (!e.collapsed) {
          var _t2 = Array.from(e.getClientRects());

          if (1 === _t2.length) return _t2[0];

          var _n = _t2.filter(function (e) {
            var t = e.width;
            return t > 1;
          });

          if (0 === _n.length) return e.getBoundingClientRect();
          if (1 === _n.length) return _n[0];
          var _n$ = _n[0],
              _r = _n$.top,
              _o = _n$.bottom,
              a = _n$.left,
              i = _n$.right;

          var _iterator = _createForOfIteratorHelper(_n),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _step.value,
                  _e = _step$value.top,
                  _t3 = _step$value.bottom,
                  u = _step$value.left,
                  s = _step$value.right;
              _e < _r && (_r = _e), _t3 > _o && (_o = _t3), u < a && (a = u), s > i && (i = s);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return new window.DOMRect(a, _r, i - a, _o - _r);
        }

        var _e2 = e,
            t = _e2.startContainer,
            n = t.ownerDocument;

        if ("BR" === t.nodeName) {
          var _o2 = t.parentNode;
          (0, r.assertIsDefined)(_o2, "parentNode");

          var _a = Array.from(_o2.childNodes).indexOf(t);

          (0, r.assertIsDefined)(n, "ownerDocument"), (e = n.createRange()).setStart(_o2, _a), e.setEnd(_o2, _a);
        }

        var o = e.getClientRects()[0];

        if (!o) {
          (0, r.assertIsDefined)(n, "ownerDocument");

          var _t4 = n.createTextNode("​");

          (e = e.cloneRange()).insertNode(_t4), o = e.getClientRects()[0], (0, r.assertIsDefined)(_t4.parentNode, "padNode.parentNode"), _t4.parentNode.removeChild(_t4);
        }

        return o;
      };
      var r = n(86);
    },
    414: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function getScrollContainer(e) {
        if (e) {
          if (e.scrollHeight > e.clientHeight) {
            var _ref = (0, o.default)(e),
                _t5 = _ref.overflowY;

            if (/(auto|scroll)/.test(_t5)) return e;
          }

          return getScrollContainer(e.parentNode);
        }
      };
      var o = r(n(896));
    },
    526: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function hiddenCaretRangeFromPoint(e, t, n, r) {
        var i = r.style.zIndex,
            u = r.style.position,
            _ref2 = (0, a.default)(r),
            _ref2$position = _ref2.position,
            s = _ref2$position === void 0 ? "static" : _ref2$position;

        "static" === s && (r.style.position = "relative"), r.style.zIndex = "10000";
        var l = (0, o.default)(e, t, n);
        return r.style.zIndex = i, r.style.position = u, l;
      };
      var o = r(n(734)),
          a = r(n(896));
    },
    736: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "__unstableStripHTML", {
        enumerable: !0,
        get: function get() {
          return N.default;
        }
      }), Object.defineProperty(t, "computeCaretRect", {
        enumerable: !0,
        get: function get() {
          return o.default;
        }
      }), Object.defineProperty(t, "documentHasSelection", {
        enumerable: !0,
        get: function get() {
          return u.default;
        }
      }), Object.defineProperty(t, "documentHasTextSelection", {
        enumerable: !0,
        get: function get() {
          return a.default;
        }
      }), Object.defineProperty(t, "documentHasUncollapsedSelection", {
        enumerable: !0,
        get: function get() {
          return i.default;
        }
      }), Object.defineProperty(t, "getOffsetParent", {
        enumerable: !0,
        get: function get() {
          return d.default;
        }
      }), Object.defineProperty(t, "getRectangleFromRange", {
        enumerable: !0,
        get: function get() {
          return s.default;
        }
      }), Object.defineProperty(t, "getScrollContainer", {
        enumerable: !0,
        get: function get() {
          return l.default;
        }
      }), Object.defineProperty(t, "insertAfter", {
        enumerable: !0,
        get: function get() {
          return _.default;
        }
      }), Object.defineProperty(t, "isEmpty", {
        enumerable: !0,
        get: function get() {
          return M.default;
        }
      }), Object.defineProperty(t, "isEntirelySelected", {
        enumerable: !0,
        get: function get() {
          return c.default;
        }
      }), Object.defineProperty(t, "isHorizontalEdge", {
        enumerable: !0,
        get: function get() {
          return f.default;
        }
      }), Object.defineProperty(t, "isNumberInput", {
        enumerable: !0,
        get: function get() {
          return b.default;
        }
      }), Object.defineProperty(t, "isRTL", {
        enumerable: !0,
        get: function get() {
          return E.default;
        }
      }), Object.defineProperty(t, "isTextField", {
        enumerable: !0,
        get: function get() {
          return p.default;
        }
      }), Object.defineProperty(t, "isVerticalEdge", {
        enumerable: !0,
        get: function get() {
          return m.default;
        }
      }), Object.defineProperty(t, "placeCaretAtHorizontalEdge", {
        enumerable: !0,
        get: function get() {
          return g.default;
        }
      }), Object.defineProperty(t, "placeCaretAtVerticalEdge", {
        enumerable: !0,
        get: function get() {
          return v.default;
        }
      }), Object.defineProperty(t, "remove", {
        enumerable: !0,
        get: function get() {
          return h.default;
        }
      }), Object.defineProperty(t, "removeInvalidHTML", {
        enumerable: !0,
        get: function get() {
          return C.default;
        }
      }), Object.defineProperty(t, "replace", {
        enumerable: !0,
        get: function get() {
          return y.default;
        }
      }), Object.defineProperty(t, "replaceTag", {
        enumerable: !0,
        get: function get() {
          return P.default;
        }
      }), Object.defineProperty(t, "safeHTML", {
        enumerable: !0,
        get: function get() {
          return T.default;
        }
      }), Object.defineProperty(t, "unwrap", {
        enumerable: !0,
        get: function get() {
          return O.default;
        }
      }), Object.defineProperty(t, "wrap", {
        enumerable: !0,
        get: function get() {
          return j.default;
        }
      });

      var o = r(n(591)),
          a = r(n(87)),
          i = r(n(73)),
          u = r(n(946)),
          s = r(n(605)),
          l = r(n(414)),
          d = r(n(723)),
          c = r(n(75)),
          f = r(n(281)),
          b = r(n(721)),
          p = r(n(906)),
          m = r(n(867)),
          g = r(n(706)),
          v = r(n(536)),
          y = r(n(920)),
          h = r(n(314)),
          _ = r(n(78)),
          O = r(n(14)),
          P = r(n(869)),
          j = r(n(845)),
          N = r(n(489)),
          M = r(n(953)),
          C = r(n(114)),
          E = r(n(610)),
          T = r(n(739));
    },
    512: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function inputFieldHasUncollapsedSelection(e) {
        if (!(0, o.default)(e) && !(0, a.default)(e)) return !1;

        try {
          var _t6 = e.selectionStart,
              _n2 = e.selectionEnd;
          return null !== _t6 && _t6 !== _n2;
        } catch (e) {
          return !1;
        }
      };
      var o = r(n(906)),
          a = r(n(721));
    },
    78: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function insertAfter(e, t) {
        (0, r.assertIsDefined)(t.parentNode, "referenceNode.parentNode"), t.parentNode.insertBefore(e, t.nextSibling);
      };
      var r = n(86);
    },
    370: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isEdge(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if ((0, d.default)(e) && "number" == typeof e.selectionStart) return e.selectionStart === e.selectionEnd && (t ? 0 === e.selectionStart : e.value.length === e.selectionStart);
        if (!e.isContentEditable) return !0;
        var r = e.ownerDocument,
            c = r.defaultView;
        (0, l.assertIsDefined)(c, "defaultView");
        var f = c.getSelection();
        if (!f || !f.rangeCount) return !1;
        var b = f.getRangeAt(0),
            p = b.cloneRange(),
            m = (0, u.default)(f),
            g = f.isCollapsed;
        g || p.collapse(!m);
        var v = (0, i.default)(p),
            y = (0, i.default)(b);
        if (!v || !y) return !1;
        var h = (0, a.default)(b);
        if (!g && h && h > v.height && m === t) return !1;

        var _ = (0, o.default)(e) ? !t : t,
            O = e.getBoundingClientRect(),
            P = _ ? O.left + 1 : O.right - 1,
            j = t ? O.top + 1 : O.bottom - 1,
            N = (0, s.default)(r, P, j, e);

        if (!N) return !1;
        var M = (0, i.default)(N);
        if (!M) return !1;
        var C = t ? "top" : "bottom",
            E = _ ? "left" : "right",
            T = M[C] - y[C],
            w = M[E] - v[E],
            D = Math.abs(T) <= 1,
            x = Math.abs(w) <= 1;
        return n ? D : D && x;
      };
      var o = r(n(610)),
          a = r(n(576)),
          i = r(n(605)),
          u = r(n(250)),
          s = r(n(526)),
          l = n(86),
          d = r(n(468));
    },
    742: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isElement(e) {
        return !!e && e.nodeType === e.ELEMENT_NODE;
      };
    },
    953: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isEmpty(e) {
        switch (e.nodeType) {
          case e.TEXT_NODE:
            return /^[ \f\n\r\t\v\u00a0]*$/.test(e.nodeValue || "");

          case e.ELEMENT_NODE:
            return !e.hasAttributes() && (!e.hasChildNodes() || Array.from(e.childNodes).every(isEmpty));

          default:
            return !0;
        }
      };
    },
    75: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isEntirelySelected(e) {
        if ((0, a.default)(e)) return 0 === e.selectionStart && e.value.length === e.selectionEnd;
        if (!e.isContentEditable) return !0;
        var t = e.ownerDocument,
            n = t.defaultView;
        (0, o.assertIsDefined)(n, "defaultView");
        var r = n.getSelection();
        (0, o.assertIsDefined)(r, "selection");
        var i = r.rangeCount ? r.getRangeAt(0) : null;
        if (!i) return !0;
        var u = i.startContainer,
            s = i.endContainer,
            l = i.startOffset,
            d = i.endOffset;
        if (u === e && s === e && 0 === l && d === e.childNodes.length) return !0;
        var c = e.lastChild;
        (0, o.assertIsDefined)(c, "lastChild");
        var f = s.nodeType === s.TEXT_NODE ? s.data.length : s.childNodes.length;
        return isDeepChild(u, e, "firstChild") && isDeepChild(s, e, "lastChild") && 0 === l && d === f;
      };
      var o = n(86),
          a = r(n(468));

      function isDeepChild(e, t, n) {
        var r = t;

        do {
          if (e === r) return !0;
          r = r[n];
        } while (r);

        return !1;
      }
    },
    281: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isHorizontalEdge(e, t) {
        return (0, o.default)(e, t);
      };
      var o = r(n(370));
    },
    776: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isHTMLInputElement(e) {
        return !!e && "INPUT" === e.nodeName;
      };
    },
    468: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isInputOrTextArea(e) {
        return "INPUT" === e.tagName || "TEXTAREA" === e.tagName;
      };
    },
    721: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isNumberInput(e) {
        return (0, o.default)(e) && "number" === e.type && !!e.valueAsNumber;
      };
      var o = r(n(776));
    },
    610: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isRTL(e) {
        return "rtl" === (0, o.default)(e).direction;
      };
      var o = r(n(896));
    },
    250: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isSelectionForward(e) {
        var t = e.anchorNode,
            n = e.focusNode,
            o = e.anchorOffset,
            a = e.focusOffset;
        (0, r.assertIsDefined)(t, "anchorNode"), (0, r.assertIsDefined)(n, "focusNode");
        var i = t.compareDocumentPosition(n);
        return !(i & t.DOCUMENT_POSITION_PRECEDING) && (!!(i & t.DOCUMENT_POSITION_FOLLOWING) || 0 !== i || o <= a);
      };
      var r = n(86);
    },
    906: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isTextField(e) {
        return (0, o.default)(e) && e.type && !["button", "checkbox", "hidden", "file", "radio", "image", "range", "reset", "submit", "number"].includes(e.type) || "TEXTAREA" === e.nodeName || "true" === e.contentEditable;
      };
      var o = r(n(776));
    },
    867: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function isVerticalEdge(e, t) {
        return (0, o.default)(e, t, !0);
      };
      var o = r(n(370));
    },
    470: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function placeCaretAtEdge(e, t, n) {
        if (!e) return;

        if (e.focus(), (0, i.default)(e)) {
          if ("number" != typeof e.selectionStart) return;
          return void (t ? (e.selectionStart = e.value.length, e.selectionEnd = e.value.length) : (e.selectionStart = 0, e.selectionEnd = 0));
        }

        if (!e.isContentEditable) return;
        var r = getRange(e, t, n);
        if (!(r && r.startContainer && e.contains(r.startContainer) || (e.scrollIntoView(t), r = r = getRange(e, t, n), r && r.startContainer && e.contains(r.startContainer)))) return;
        var o = e.ownerDocument,
            u = o.defaultView;
        (0, a.assertIsDefined)(u, "defaultView");
        var s = u.getSelection();
        (0, a.assertIsDefined)(s, "selection"), s.removeAllRanges(), s.addRange(r);
      };
      var o = r(n(526)),
          a = n(86),
          i = r(n(468)),
          u = r(n(610));

      function getRange(e, t, n) {
        var r = e.ownerDocument,
            a = (0, u.default)(e) ? !t : t,
            i = e.getBoundingClientRect();
        void 0 === n && (n = t ? i.right - 1 : i.left + 1);
        var s = a ? i.bottom - 1 : i.top + 1;
        return (0, o.default)(r, n, s, e);
      }
    },
    706: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function placeCaretAtHorizontalEdge(e, t) {
        return (0, o.default)(e, t, void 0);
      };
      var o = r(n(470));
    },
    536: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function placeCaretAtVerticalEdge(e, t, n) {
        return (0, o.default)(e, t, null == n ? void 0 : n.left);
      };
      var o = r(n(470));
    },
    114: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function removeInvalidHTML(e, t, n) {
        var r = document.implementation.createHTMLDocument("");
        return r.body.innerHTML = e, (0, o.default)(r.body.childNodes, r, t, n), r.body.innerHTML;
      };
      var o = r(n(646));
    },
    314: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function remove(e) {
        (0, r.assertIsDefined)(e.parentNode, "node.parentNode"), e.parentNode.removeChild(e);
      };
      var r = n(86);
    },
    869: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function replaceTag(e, t) {
        var n = e.ownerDocument.createElement(t);

        for (; e.firstChild;) {
          n.appendChild(e.firstChild);
        }

        return (0, r.assertIsDefined)(e.parentNode, "node.parentNode"), e.parentNode.replaceChild(n, e), n;
      };
      var r = n(86);
    },
    920: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function replace(e, t) {
        (0, o.assertIsDefined)(e.parentNode, "processedNode.parentNode"), (0, a.default)(t, e.parentNode), (0, i.default)(e);
      };
      var o = n(86),
          a = r(n(78)),
          i = r(n(314));
    },
    739: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function safeHTML(e) {
        var _document$implementat = document.implementation.createHTMLDocument(""),
            t = _document$implementat.body;

        t.innerHTML = e;
        var n = t.getElementsByTagName("*");
        var r = n.length;

        for (; r--;) {
          var _e3 = n[r];
          if ("SCRIPT" === _e3.tagName) (0, o.default)(_e3);else {
            var _t7 = _e3.attributes.length;

            for (; _t7--;) {
              var _n3 = _e3.attributes[_t7].name;
              _n3.startsWith("on") && _e3.removeAttribute(_n3);
            }
          }
        }

        return t.innerHTML;
      };
      var o = r(n(314));
    },
    489: function _(e, t, n) {
      "use strict";

      var r = n(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function stripHTML(e) {
        e = (0, o.default)(e);
        var t = document.implementation.createHTMLDocument("");
        return t.body.innerHTML = e, t.body.textContent || "";
      };
      var o = r(n(739));
    },
    14: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function unwrap(e) {
        var t = e.parentNode;

        for ((0, r.assertIsDefined)(t, "node.parentNode"); e.firstChild;) {
          t.insertBefore(e.firstChild, e);
        }

        t.removeChild(e);
      };
      var r = n(86);
    },
    845: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function wrap(e, t) {
        (0, r.assertIsDefined)(t.parentNode, "referenceNode.parentNode"), t.parentNode.insertBefore(e, t), e.appendChild(t);
      };
      var r = n(86);
    },
    161: function _(e, t) {
      "use strict";

      function buildSelector(e) {
        return [e ? '[tabindex]:not([tabindex^="-"])' : "[tabindex]", "a[href]", "button:not([disabled])", 'input:not([type="hidden"]):not([disabled])', "select:not([disabled])", "textarea:not([disabled])", 'iframe:not([tabindex^="-"])', "object", "embed", "area[href]", "[contenteditable]:not([contenteditable=false])"].join(",");
      }

      function isVisible(e) {
        return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0;
      }

      function isValidFocusableArea(e) {
        var t = e.closest("map[name]");
        if (!t) return !1;
        var n = e.ownerDocument.querySelector('img[usemap="#' + t.name + '"]');
        return !!n && isVisible(n);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.find = function find(e) {
        var _ref3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            _ref3$sequential = _ref3.sequential,
            t = _ref3$sequential === void 0 ? !1 : _ref3$sequential;

        var n = e.querySelectorAll(buildSelector(t));
        return Array.from(n).filter(function (e) {
          if (!isVisible(e)) return !1;
          var t = e.nodeName;
          return "AREA" !== t || isValidFocusableArea(e);
        });
      };
    },
    104: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = {
        focus: !0
      };
      t.focus = void 0;

      var o = _interopRequireWildcard(n(161)),
          a = _interopRequireWildcard(n(746)),
          i = n(736);

      Object.keys(i).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(r, e) || e in t && t[e] === i[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return i[e];
          }
        }));
      });
      var u = n(561);
      Object.keys(u).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(r, e) || e in t && t[e] === u[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return u[e];
          }
        }));
      });
      var s = n(513);

      function _getRequireWildcardCache(e) {
        if ("function" != typeof WeakMap) return null;
        var t = new WeakMap(),
            n = new WeakMap();
        return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
          return e ? n : t;
        })(e);
      }

      function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        if (null === e || "object" != typeof e && "function" != typeof e) return {
          default: e
        };

        var n = _getRequireWildcardCache(t);

        if (n && n.has(e)) return n.get(e);
        var r = {},
            o = Object.defineProperty && Object.getOwnPropertyDescriptor;

        for (var a in e) {
          if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
            var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
            i && (i.get || i.set) ? Object.defineProperty(r, a, i) : r[a] = e[a];
          }
        }

        return r.default = e, n && n.set(e, r), r;
      }

      Object.keys(s).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(r, e) || e in t && t[e] === s[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return s[e];
          }
        }));
      });
      var l = {
        focusable: o,
        tabbable: a
      };
      t.focus = l;
    },
    561: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getPhrasingContentSchema = getPhrasingContentSchema, t.isPhrasingContent = function isPhrasingContent(e) {
        var t = e.nodeName.toLowerCase();
        return getPhrasingContentSchema().hasOwnProperty(t) || "span" === t;
      }, t.isTextContent = function isTextContent(e) {
        var t = e.nodeName.toLowerCase();
        return o.hasOwnProperty(t) || "span" === t;
      };
      var r = n(793);
      var o = {
        strong: {},
        em: {},
        s: {},
        del: {},
        ins: {},
        a: {
          attributes: ["href", "target", "rel", "id"]
        },
        code: {},
        abbr: {
          attributes: ["title"]
        },
        sub: {},
        sup: {},
        br: {},
        small: {},
        q: {
          attributes: ["cite"]
        },
        dfn: {
          attributes: ["title"]
        },
        data: {
          attributes: ["value"]
        },
        time: {
          attributes: ["datetime"]
        },
        var: {},
        samp: {},
        kbd: {},
        i: {},
        b: {},
        u: {},
        mark: {},
        ruby: {},
        rt: {},
        rp: {},
        bdi: {
          attributes: ["dir"]
        },
        bdo: {
          attributes: ["dir"]
        },
        wbr: {},
        "#text": {}
      };
      (0, r.without)(Object.keys(o), "#text", "br").forEach(function (e) {
        o[e].children = (0, r.omit)(o, e);
      });

      var a = _objectSpread(_objectSpread({}, o), {}, {
        audio: {
          attributes: ["src", "preload", "autoplay", "mediagroup", "loop", "muted"]
        },
        canvas: {
          attributes: ["width", "height"]
        },
        embed: {
          attributes: ["src", "type", "width", "height"]
        },
        img: {
          attributes: ["alt", "src", "srcset", "usemap", "ismap", "width", "height"]
        },
        object: {
          attributes: ["data", "type", "name", "usemap", "form", "width", "height"]
        },
        video: {
          attributes: ["src", "poster", "preload", "autoplay", "mediagroup", "loop", "muted", "controls", "width", "height"]
        }
      });

      function getPhrasingContentSchema(e) {
        return "paste" !== e ? a : (0, r.omit)(_objectSpread(_objectSpread({}, a), {}, {
          ins: {
            children: a.ins.children
          },
          del: {
            children: a.del.children
          }
        }), ["u", "abbr", "data", "time", "wbr", "bdi", "bdo"]);
      }
    },
    746: function _(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.find = function find(e) {
        return filterTabbable((0, o.find)(e));
      }, t.findNext = function findNext(e) {
        var t = (0, o.find)(e.ownerDocument.body),
            n = t.indexOf(e),
            a = t.slice(n + 1);
        return (0, r.first)(filterTabbable(a));
      }, t.findPrevious = function findPrevious(e) {
        var t = (0, o.find)(e.ownerDocument.body),
            n = t.indexOf(e);
        return t.length = n, (0, r.last)(filterTabbable(t));
      }, t.isTabbableIndex = isTabbableIndex;
      var r = n(793),
          o = n(161);

      function getTabIndex(e) {
        var t = e.getAttribute("tabindex");
        return null === t ? 0 : parseInt(t, 10);
      }

      function isTabbableIndex(e) {
        return -1 !== getTabIndex(e);
      }

      function mapElementToObjectTabbable(e, t) {
        return {
          element: e,
          index: t
        };
      }

      function mapObjectTabbableToElement(e) {
        return e.element;
      }

      function compareObjectTabbables(e, t) {
        var n = getTabIndex(e.element),
            r = getTabIndex(t.element);
        return n === r ? e.index - t.index : n - r;
      }

      function filterTabbable(e) {
        return e.filter(isTabbableIndex).map(mapElementToObjectTabbable).sort(compareObjectTabbables).map(mapObjectTabbableToElement).reduce(function createStatefulCollapseRadioGroup() {
          var e = {};
          return function collapseRadioGroup(t, n) {
            var o = n.nodeName,
                a = n.type,
                i = n.checked,
                u = n.name;
            if ("INPUT" !== o || "radio" !== a || !u) return t.concat(n);
            var s = e.hasOwnProperty(u);
            if (!i && s) return t;

            if (s) {
              var _n4 = e[u];
              t = (0, r.without)(t, _n4);
            }

            return e[u] = n, t.concat(n);
          };
        }(), []);
      }
    },
    86: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.assertIsDefined = function assertIsDefined(e, t) {};
    },
    793: function _(e) {
      "use strict";

      e.exports = require("lodash");
    }
  }, t = {}, n = function __webpack_require__(n) {
    var r = t[n];
    if (void 0 !== r) return r.exports;
    var o = t[n] = {
      exports: {}
    };
    return e[n](o, o.exports, __webpack_require__), o.exports;
  }(104), n;
  var e, t, n;
});